import React from 'react'
import AuthContext from '../auth/AuthContext'
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import './HeaderBar.scss'
import { Link, useHistory } from 'react-router-dom';
import { FaChevronDown, FaDownload, FaSignOutAlt, FaUserAlt, FaUserCog } from 'react-icons/all';
import { getRolesPrettyName } from '../common/RoleUtils';
import { BHeaderUser } from '../common/BCommonComponents';

export function HeaderBar() {
	const history = useHistory();
	const auth = React.useContext(AuthContext);
	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleGoToImpostazioni = () => {
		setAnchorEl(null);
		history.push('/impostazioniutente');
	}

	return (
		<div id="bs-header-bar">
			{auth.state.isAuthenticated && <img id="bs-header-logo" src="/logo_orizz_bianco.svg" alt="logo top bar"></img>}
			{auth.state.isAuthenticated &&
			<div id="bs-header-tools">
				<Button aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick}>
					<FaUserAlt size={25}/>
					<div>
						<BHeaderUser className="mb-0">{auth.state.prettyName}</BHeaderUser>
						<BHeaderUser className="text-capitalize">
							{auth.state.roles && getRolesPrettyName(auth.state.roles)}</BHeaderUser>
						<BHeaderUser className="mb-0">{auth.state.puntoServizioLogged?.name}</BHeaderUser>
					</div>
					<FaChevronDown size={20}/>
				</Button>
				<Menu
					anchorEl={anchorEl}
					keepMounted
					open={Boolean(anchorEl)}
					onClose={handleClose}
					getContentAnchorEl={null}
					anchorOrigin={{
						vertical: "bottom",
						horizontal: "center",
					}}
					transformOrigin={{
						vertical: "top",
						horizontal: "center",
					}}
				>
					<MenuItem onClick={handleGoToImpostazioni} className="custom-menu-item"><FaUserCog size={20} className="mr-2 color-primary"/>Impostazioni Operatore</MenuItem>
					<MenuItem className="custom-menu-item">
						<a href="/asset/manuale_utente.pdf" download>
							<FaDownload size={20} className="mr-2 color-primary"/>Scarica Manuale
						</a>
					</MenuItem>
					<MenuItem onClick={handleClose} component={Link} to="/logout"><FaSignOutAlt size={20} className="mr-2 color-primary"/>Disconnetti</MenuItem>
				</Menu>

			</div>}
		</div>
	)
}
